import { replaceHash } from '@/services/mixins/playerMixins'

export default {
  getIsLoading: state => state.isLoading,
  getPlayers: state => state.players.options,
  getDefaultPlayers: state => state.defaultPlayers,
  getPlayersSelectList: state => state.playersSelectList,
  getPlayer: state => state.player,
  getOptions: state => state.options,
  getPagination: state => state.pagination,
  getCurrentPage: state => state.filters.params.page,
  getPageLength: state => state.filters.params.take,

  getPlayerFloatOnScroll: state => state.player.floatOnScroll,
  getPlayerFloatBorderWidth: state => state.player.floatBorderWidth,
  getPlayerFloatBorderColor: state => state.player.floatBorderColor,

  getPlayerFloatOnMobile: state => state.player.floatOnMobile,
  getPlayerFloatRequiresInteraction: state => state.player.floatRequiresInteraction,
  getPlayerFloatBorder: state => state.player.floatBorder,
  getPlayerSharing: state => state.player.sharing,
  getPlayerFloatDismissible: state => state.player.floatDismissible,
  getPlayerFloatWidth: state => state.player.floatWidth,

  getPlayerLogoOn: state => state.player.logoOn,
  getPlayerLogoUrl: state => state.player.logoUrl,
  getPlayerLogoPath: state => state.player.logoPath,
  getPlayerLogoDefaultOpacity: state => state.player.logoDefaultOpacity,
  getPlayerLogoInactiveOpacity: state => state.player.logoInactiveOpacity,
  getPlayerLogoPositionOptionId: state => state.player.logoPositionOptionId,
  getPlayerLogoOnClickUrl: state => state.player.logoOnClickUrl,

  getPlayerAdScheduleId: state => state.player.adScheduleId,
  getPlayerAdvertising: state => state.player.advertising,

  getPlayerReleaseChannel: state => state.player.releaseChannel,
  getAllPlayerReleaseChannels: state => state.player.releaseChannels,
  getPlayerPlayerSizeType: state => state.player.playerSizeType,
  getResponsive: state => state.player.responsive,
  getPlayerPreloadOption: state => state.player.preloadOption,
  getPlayerDefaultBandwidthEstimateOption: state => state.player.defaultBandwidthEstimateOption,
  getPlayerResponsiveSizeOption: state => state.player.responsiveSizeOption,
  getPlayerLogoPositionOption: state => state.player.logoPositionOption,
  getPlayerFloatPositionOption: state => state.player.floatPositionOption,
  getPlayerPlayerSocialNetworks: state => state.player.playerSocialNetworks,
  getPlayerPlayerSocialNetworkIds: state => state.player.socialNetworkIds,
  getConfig(state) {
    return {
      // config: {
      size: {
        sizeType: state.player.playerSizeType.name.toUpperCase(),
        width: state.player.width,
        height: state.player.height,
      },
      responsive: state.player.responsive,
      autoplay: state.player.autoPlay,
      casting: state.player.casting,
      autostartOnLoad: {
        state: state.player.autoStartOnLoad,
        onMobile: state.player.autoStartOnLoadMobile,
        onData: state.player.autoStartOnLoadOnData,
      },
      autostartOnViewable: {
        state: state.player.autoStartOnViewableOn,
      },
      autopauseOnViewable: {
        state: state.player.autoPauseOnViewableOn,

      },
      pauseOtherVideos: state.player.pauseOtherVideos,
      focusOnAutostart: state.player.focusOnAutoStart,
      pauseOnRelatedShown: state.player.pauseWhenRelatedIsShown,
      volume: state.player.volume,
      muted: state.player.muteOnStart,
      debug: state.player.debug,
      adsRequireInteraction: state.player.adsRequireInteraction,
      loop: state.player.loopContent,
      highlightCurrentVideo: state.player.highlightCurrentVideo,
      allowSeekOnLive: state.player.allowSeekOnLive,
      seekLiveAfterPause: state.player.seekLiveAfterPause,
      onHoverPlay: state.player.onHoverPlay,
      socialMedia: state.player?.playerSocialNetworks.map(x => x.value),
      float: {
        state: state.player.floatOnScroll,
        onMobile: state.player.floatOnMobile,
        position: state.player.floatPositionOption.value,
        dismissible: state.player.floatDismissible,
        style: {
          width: state.player.floatWidth,
          border: `${state.player.floatBorderWidth}px solid ${state.player.floatBorderColor}`,
        },
        requiresInteraction: state.player.floatRequiresInteraction,
      },
      playbackRates: state.player.enablePlayBackRateControls ? [0.25, 0.5, 0.75, 1, 2, 4] : [],
      controls: {
        play: state.player.playButton,
        mute: state.player.muteButton,
        volume: state.player.volumeSlider,
      },
      lang: {
        locale: 'en',
        controls: {
          play: state.player.Play,
          pause: state.player.Pause,
          next: state.player.Next,
          replay: state.player.Replay,
          volume: state.player.VolumeText,
          mute: state.player.Mute,
          unmute: state.player.UnMute,
          live: state.player.Live,
          settings: state.player.Settings,
          theater: state.player.Theater,
          fullscreen: state.player.FullScreen,
          chromecast: state.player.Chromecast,
          airplay: state.player.Airplay,
          pictureInPicture: state.player.PictureInPicture,
          skipIntro: state.player.SkipIntro,
          skipAd: state.player.Skipad,
          playlistTitle: state.player.ContinueWatching,
          related: state.player.Playlist,
          upNext: state.player.upNext,
          continueAfterPause: state.player.continueAfterPause,
          audioOnly: state.player.AudioOnly,
          videoMode: state.player.VideoMode,
          rewind: state.player.Rewind,
          forward: state.player.Forward,
        },
        settings: {
          quality: state.player.Quality,
          subtitles: state.player.Subtitles,
          autoplay: state.player.Autoplay,
          playbackRate: state.player.PlaybackRate,
          auto: state.player.Auto,
          off: state.player.Off,
          on: state.player.On,
          normal: state.player.Normal,
          share: state.player.Share,
          autoGeneratedSubtitles: state.player.AutoGeneratedSubtitles,
          refresh: state.player.Refresh,
          options: state.player.SubtitleOptions,
          subtitleOptions: {
            reset: state.player.SubtitleReset,
            size: state.player.SubtitleSize,
            style: state.player.SubtitleStyle,

            sizeOptions: {
              small: state.player.SubtitleSmall,
              medium: state.player.SubtitleMedium,
              large: state.player.SubtitleLarge,
            },
            styleOptions: {
              dropShadow: state.player.SubtitleDropShadow,
              dark: state.player.SubtitleDark,
              light: state.player.SubtitleLight,
              contrast: state.player.SubtitleContrast,
            },
          },
        },
        ads: {
          ad: state.player.Ad,
          skip: state.player.Skip,
          skipIn: state.player.SkipIn,
          visit: state.player.Visit,
          info: state.player.Info,
          simultaneousAds: state.player.SimultaneousAds,
          adAnnouncement: state.player.AdAnnouncement,
        },
        messages: {
          playbackErrorTitle: state.player.PlaybackErrorTitle,
          playbackErrorDescription: state.player.PlaybackErrorDescription,
          geoBlockedTitle: state.player.GeoBlockedTitle,
          geoBlockedDescription: state.player.GeoBlockedDescription,
          streamInterruptedTitle: state.player.StreamInterruptedTitle,
          streamInterruptedDescription: state.player.StreamInterruptedDescription,
          streamStartingTitle: state.player.StreamStartingTitle,
          streamStartingDescription: state.player.StreamStartingDescription,
          unpublishedTitle: state.player.UnpublishedTitle,
          unpublishedDescription: state.player.UnpublishedDescription,
          privateTitle: state.player.PrivateTitle,
          privateDescription: state.player.PrivateDescription,
          paywallRestrictedHover: state.player.PaywallRestrictedHover,
          paywallRestrictedTitle: state.player.PaywallRestrictedTitle,
          paywallRestrictedDescription: state.player.PaywallRestrictedDescription,
          paywallRestrictedButton: state.player.PaywallRestrictedButton,
        },

      },
      skin: {
        icons: {
          default: state.player.controlBarIconsDefaultColor,
          hover: state.player.controlBarIconsHoverColor,
        },
        slider: {
          progress: state.player.controlBarSliderProgressColor,
          rail: state.player.controlBarSliderRailColor,
          dragger: state.player.controlBarSliderDraggerColor,
        },
      },
      // },
    }
  },
  getEndpointObject(state) {
    const {
      controlBarTextColor,
      controlBarBackgroundColor,
      controlBarIconsDefaultColor,
      controlBarIconsHoverColor,
      controlBarSliderProgressColor,
      controlBarSliderRailColor,
      controlBarSliderDraggerColor,
      controlBarTimesliderBufferColor,
      controlBarTimeSliderOnAdProgressColor,
      controlBarTimeSliderOnAdRailColor,
      controlBarTimeSliderOnAdDraggerColor,
      controlBarVolumeProgressColor,
      controlBarVolumeRailColor,
      controlBarVolumeDraggerColor,
      controlBarVolumeNotifierColor,
      controlBarLoaderColor,
      menuBackroundDefaultColor,
      menuBackroundHoverColor,
      menuLinksDefaultColor,
      menuLinksHoverColor,
      menuAutoplayOnColor,
      menuAutoplayOffColor,
      playlistBackgroundColor,
      playlistTextColor,
      playlistIconsArrActiveColor,
      playlistIconsArrInactiveColor,
      playlistIconsCloseColor,
      playlistCardBackgroundColor,
      playlistCardTitleColor,
      playlistCardDurationTextColor,
      playlistCardDurationBackgroundColor,
      playlistCardIconPlayDefaulColor,
      playlistCardIconPlayHoverColor,
      nextVideoBackgroundColor,
      nextVideoTextColor,
      nextVideoTsRailColor,
      nextVideoTsProgressColor,
      nextVideoTsIconsCloseColor,
      nextVideoIconsPlayDefaultColor,
      nextVideoIconsPlayHoverColor,
      tooltipsTextColor,
      tooltipsBackroundColor,
      floatBorderColor,
      ...player
    } = state.player
    return {
      ...player,
      // controlBarDurationColor: playerMixins.default.methods.replaceHash(state.player.),

      controlBarIconsDefaultColor: replaceHash(controlBarIconsDefaultColor),
      controlBarIconsHoverColor: replaceHash(controlBarIconsHoverColor),
      controlBarSliderProgressColor: replaceHash(controlBarSliderProgressColor),
      controlBarSliderRailColor: replaceHash(controlBarSliderRailColor),
      controlBarSliderDraggerColor: replaceHash(controlBarSliderDraggerColor),

    }
  },
  getCustomizeColorsObject() {
    return [
      {
        name: 'Control Bar',
        id: 'controlbar',
        elements: [
          {
            name: 'Icons',
            colors: [
              {
                label: 'Default',
                prop: 'controlBarIconsDefaultColor',
              },
              {
                label: 'Hover',
                prop: 'controlBarIconsHoverColor',
              },
            ],
          },
          {
            name: 'Timeslider',
            colors: [
              {
                label: 'Progress',
                prop: 'controlBarSliderProgressColor',
              },
              {
                label: 'Rail',
                prop: 'controlBarSliderRailColor',
              },
              {
                label: 'Dragger',
                prop: 'controlBarSliderDraggerColor',
              },
            ],
          },
        ],
      },

    ]
  },
  getCheckboxes() {
    return [
      {
        label: 'Show play button',
        prop: 'playButton',
      },
      {
        label: 'Show volume slider',
        prop: 'volumeSlider',
      },
      {
        label: 'Show mute button',
        prop: 'muteButton',
      },
    ]
  },

}
